/* import __COLOCATED_TEMPLATE__ from './instruction.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();